import styled from "styled-components";

import { media } from "constants/media";

export const Container = styled.section`
    background: var(--color-white);
    padding: 24px;

    ${media.mdUp} {
        background: var(--color-grey-50);
        padding: 48px;
    }
`;

export const Wrapper = styled.div`
    margin: 0 auto;
    max-width: 272px;

    ${media.mdUp} {
        background: var(--color-white);
        border-radius: 24px;
        display: flex;
        gap: 48px;
        max-width: 992px;
        padding: 48px;
    }
`;

export const ImageWrapper = styled.div`
    margin-bottom: 16px;

    img {
        border-radius: 24px;
    }

    ${media.mdUp} {
        align-self: center;
        width: 55%;
    }
`;

export const FilterOptionsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const FilterOption = styled.span`
    align-items: center;
    background: var(--color-grey-50);
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    font-size: var(--type-paragraph-font-size);
    font-weight: 700;
    gap: 12px;
    letter-spacing: 1px;
    margin-bottom: 4px;
    margin-right: 8px;
    padding: 4px 8px;

    &.department-needed {
        background: var(--color-red-50);
        color: var(--color-white);
        cursor: default;

        &:hover {
            background: var(--color-red-50);
            color: var(--color-white);
            outline: unset;
        }
    }

    &:hover {
        background-color: var(--color-white);
        outline: 1px solid var(--color-black);
    }
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.mdUp} {
        justify-content: space-between;

        label {
            width: 100%;
        }
    }
`;

export const NameAndEmailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.mdUp} {
        flex-direction: row;
        justify-content: space-between;

        label {
            width: 100%;
        }
    }
`;

export const Form = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    button {
        cursor: pointer;
        justify-content: center;
        margin-top: 16px;
        width: 272px;

        ${media.mdUp} {
            margin-top: 24px;
            width: 100%;
        }
    }
`;

export const StyledErrorMessage = styled.p`
    color: var(--color-red-50);
    font-size: var(--type-sub-text-font-size-sub-text);
    font-weight: 700;
    line-height: var(--type-sub-text-line-height);
    margin-top: 4px;
`;
